import React, { Fragment, useState } from "react";
import { Row, Col, Card, Input, Icon } from 'antd';
import cloneDeep from 'lodash/cloneDeep';
import './styles.css';
import TranslatedText from "translations/TranslatedText";
import OptionsTable from './OptionsTable';
import SelectGroup from './SelectGroup';

export default function OptionsCard(props) {
  const {
    options,
    setOptions,
    numSelects,
    focusAfterAdd,
  } = props;
  const [value, setValue] = useState('');
  const [select, setSelect] = useState(1);

  const clearInput = () => setValue('');

  const addOption = () => {
    const optionsClone = cloneDeep(options);
    optionsClone.push({ value, is_answer: false, select })
    setOptions(optionsClone);
  }

  const addOnEnterKey = (event) => {
    if (event.keyCode === 13 || event.key === 'Enter') {
      addOption();
      if (focusAfterAdd) {
        event.target.focus();
        event.target.select();
      }
    }
  }

  const onSelectGroup = (value) => {
    setSelect(value);
  }

  const removeOption = (option) => {
    const optionsClone = cloneDeep(options);
    optionsClone.splice(option.key, 1);
    setOptions(optionsClone);
  }

  const onChangeGroup = (option, select) => {
    const optionsClone = cloneDeep(options);
    optionsClone[option.key].select = select;
    setOptions(optionsClone);
  }

  const onChangeIsAnswer = (option, is_answer) => {
    const optionsClone = cloneDeep(options);
    optionsClone[option.key].is_answer = is_answer;
    setOptions(optionsClone);
  }

  const onChangeAnswer = (option, answer) => {
    const optionsClone = cloneDeep(options);
    optionsClone[option.key].value = answer;
    setOptions(optionsClone);
  }

  return (
    <Fragment>
      <Card size="small"
            title={<TranslatedText
                    id="settings.form.selectblanktext.card.title" />}
      >
        <Input value={value}
               onChange={event=>setValue(event.target.value)}
               onKeyDown={addOnEnterKey}
               allowClear
               addonAfter={<SelectGroup onChange={onSelectGroup}
                                        numSelects={numSelects} />}
        />
        <OptionsTable onRemoveOption={removeOption}
                      options={options} numSelects={numSelects}
                      onChangeGroup={onChangeGroup}
                      onChangeIsAnswer={onChangeIsAnswer}
                      onChangeAnswer={onChangeAnswer}
        />
      </Card>
    </Fragment>
  );
}
